export default __webpack_public_path__ + "static/media/image-three.a867761d.jpg";